import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  fetchChatbotEventAccess,
  resetChatbotEventAccess,
} from "../../features/Chatbot/chatbotEventAccessSlice";

const RequireChatbotEvent = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const access = useSelector((state) => state.chatbotEventAccess);
  const accountId = auth.user?.accountId;
  const authBootstrapping =
    auth.isLoading || (auth.isAuthenticated && !auth.user?._id);

  useEffect(() => {
    if (!accountId) {
      if (!authBootstrapping) {
        dispatch(resetChatbotEventAccess());
      }
      return;
    }
    if (access.accountId !== Number(accountId) || !access.loaded) {
      dispatch(fetchChatbotEventAccess(accountId));
    }
  }, [dispatch, accountId, access.accountId, access.loaded, authBootstrapping]);

  if (authBootstrapping) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50 text-sm text-gray-500">
        Đang tải...
      </div>
    );
  }

  if (!accountId) {
    return <Navigate to="/" replace />;
  }

  if (access.loading || access.accountId !== Number(accountId) || !access.loaded) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50 text-sm text-gray-500">
        Đang tải...
      </div>
    );
  }

  if (!access.enabled) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireChatbotEvent;
